import * as React from "react";

import { CPSetting } from "./setting";
import { CPParameterSetting } from "./parameter";
import styled from "styled-components";
import { ErrorObject } from "../../../../../../../../server/types/error";
import { Job } from "../../../../../../../../server/models/job";
import {
	CurrentProductCorrectionValue,
	CurrentProductData,
	SimulationPredictionData,
	SimulationReferenceSourceData,
} from "../../../../../../../../server/types/request/report/simulation";
import { ChangeRateValue } from "../../../../../../../../server/models/cp2";
import { Constant } from "../../../../../../../../server/analytics/v3/output/executive/demand-forecast/aggregate";
import { TestOnlyConceptKey } from "../../../../../../../../server/models/concept";

const WrapArea = styled.div`
	margin: 0.8rem;
`;
export type CPPageProps = {
	constValue: Constant;
	currentProduct: CurrentProductData;
	referenceSourceData: SimulationReferenceSourceData;
	data: { [key in TestOnlyConceptKey]?: SimulationPredictionData };
	errors?: ErrorObject;
	job: Job;
	maxRecognition: number;
	goalRecognitionRate: number;
	onChange: <K extends keyof CurrentProductCorrectionValue>(key: K, value: CurrentProductCorrectionValue[K]) => void;
	onSubmitPurchaseRate: () => void;
	onSubmitRecognitionRate: () => void;
	hasEditRole: boolean;
	onClear: () => void;
};

export const CPPage = React.memo<CPPageProps>(
	({
		constValue,
		currentProduct,
		referenceSourceData,
		data,
		onChange,
		errors,
		onSubmitPurchaseRate,
		onSubmitRecognitionRate,
		hasEditRole,
		job,
		maxRecognition,
		goalRecognitionRate,
		onClear,
	}) => {
		const { correctionValue, initialValue } = currentProduct;
		const onChangePurchaseRate = React.useCallback(
			(key: keyof ChangeRateValue, value: ChangeRateValue[keyof ChangeRateValue]) => {
				onChange("purchaseRate", { ...(correctionValue.purchaseRate ?? {}), [key]: value } as any);
			},
			[correctionValue, onChange],
		);
		const onChangeRatio = React.useCallback(
			<K extends keyof ChangeRateValue>(name: K, value: ChangeRateValue[K]) => {
				console.log({ ...(correctionValue.recognitionRate ?? {}), [name]: value });
				onChange("recognitionRate", { ...(correctionValue.recognitionRate ?? {}), [name]: value } as any);
			},
			[correctionValue, onChange],
		);
		return (
			<WrapArea>
				<CPSetting
					cp={correctionValue}
					onChange={onChangePurchaseRate}
					errors={errors}
					onSubmit={onSubmitPurchaseRate}
					hasEditRole={hasEditRole}
					onClear={onClear}
					job={job}
				/>
				<CPParameterSetting
					constValue={constValue}
					data={data}
					initialValue={initialValue}
					referenceSourceData={referenceSourceData}
					onSubmit={onSubmitRecognitionRate}
					hasEditRole={hasEditRole}
					cp={correctionValue}
					job={job}
					maxRecognition={maxRecognition}
					goalRecognitionRate={goalRecognitionRate}
					onChangeRatio={onChangeRatio}
				/>
			</WrapArea>
		);
	},
);
